import React, { useMemo } from 'react';
import ReactTable from 'react-table';
import { getMinRowsInTable, mustBeArray } from '../../utils';

const LinkClientList = ({data, handleSelection, selectedClientLocation, className, loading}) => {
    const getButtonClassName = (id) => {
        if(selectedClientLocation.id === id || !selectedClientLocation.id){
            return "btn btn-primary";
        }
        return "btn btn-default";
    };
    const columns = useMemo(() => {
        return([ 
            {
                id: 'companyName',
                Header: 'Client Name',
                accessor: x => x.companyName,
                Cell: row => <div className='pl-h'>{row.original.companyName}</div>                           
            },
            {
              id: "select",
              accessor: (x) => x.selected,
              Header: "",
              maxWidth: 160,
              sortable: false,
              Cell: (row) => (
                <div className="flex justify-content-center">
                  <button
                    className={`btn ${getButtonClassName(row.original.id)}`}
                    onClick={() => handleSelection({id: row.original.id, type: "client"})}
                  >
                    Select
                  </button>
                </div>
              ),
            }
        ]);
    },[data, selectedClientLocation.id]);
    return(
        <ReactTable
            sortable={false}
            filterable={false}
            showPagination={false}
                // mustBeArray(data).length !== 0}
            data={data}
            // defaultPageSize={5}
            columns={columns}
            minRows={getMinRowsInTable(data, 5)} 
            className={`${className || ""} scroll-table`}
            loading={loading}
        />
    );
};
export default LinkClientList;